import React from 'react';
import {  Row, Col } from 'reactstrap';
export default function TechSpecsRpt({exportObj, onChangeExportFeature}){
  return(
    <div className="export-module-card">
      <div className="rpt-card-header">
        <h2>Technical Specification</h2>
      </div>
      <div className="rpt-card-body">
        <div className="export-items">
          <div className="">
            <Row className="flex-centered">
              <Col xs="5">
                <label className="flex-centered export-label">
                  <input type="checkbox"
                    onChange={(e) => onChangeExportFeature(e.target.checked, 'overview')}
                    checked={exportObj.tech_specs && exportObj.tech_specs.overview && exportObj.tech_specs.overview.export ? true:false}
                  />
                  <span>Overview Summary</span>
                </label>
              </Col>
              <Col xs="4">
                <div className="export-avial">
                  <h6>Export Format</h6>
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <label>
                        <input name="format" checked={true} type="radio" name="OverviewSummary" />
                        <span>PDF</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div className="export-items">
          <div className="">
            <Row className="flex-centered">
              <Col xs="5">
                <label className="flex-centered export-label">
                  <input type="checkbox"
                    onChange={(e) => onChangeExportFeature(e.target.checked, 'marketing')}
                    checked={exportObj.tech_specs && exportObj.tech_specs.marketing && exportObj.tech_specs.marketing.export ? true:false}
                  />
                  <span>Marketing Summary</span>
                </label>
              </Col>
              <Col xs="4">
                <div className="export-avial">
                  <h6>Export Format</h6>
                  <ul className="list-inline">
                    <li className="list-inline-item">
                      <label>
                        <input name="format" checked={true} type="radio" name='MarketingSummary' />
                        <span>PDF</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  )
}
